/* global BigInt */
export const MEDIA_TARIFF_V1018 = 'media_tariff';
export const MEDIA_QUANTITIES_V1018 = [
  'calls', 'output_count', 'output_seconds', 'input_seconds', 'audio_seconds',
  'input_images', 'input_tokens', 'output_tokens', 'input_pixels', 'output_pixels',
];
export const MEDIA_DIMENSIONS_V1018 = [
  'resolution', 'mode', 'model_variant', 'operation', 'audio', 'voice',
  'reference_video', 'multi_shot', 'effect', 'recommended_prompt', 'input_image_count',
  'output_pixels', 'requested_seconds',
  'quality', 'aspect_ratio', 'size', 'output_format', 'background',
];
export const MEDIA_NUMERIC_DIMENSIONS_V1018 = ['input_image_count', 'output_pixels', 'requested_seconds'];
export const hasMediaTariffV1018 = (rows = []) =>
  rows.some(row => row.meter === MEDIA_TARIFF_V1018);

export function mediaTariffScopeV1018(a = {}) {
  const pieces = [a.media_kind, a.group, `${a.quantity} / ${a.step || '1'}`,
    `(${a.from || '0'}, ${a.to || 'unbounded'}]`, a.rounding || 'exact', a.service_tier || 'standard'];
  for (const [kind, operator] of [['when', '='], ['when_min', '>='], ['when_max', '<=']]) {
    for (const [key, value] of Object.entries(a[kind] || {})) pieces.push(`${key}${operator}${value}`);
  }
  if (a.optional) pieces.push('optional');
  return pieces.filter(Boolean).join(' / ');
}

export function newMediaTariffV1018(media = 'video', quantity = 'output_seconds') {
  return {
    meter: MEDIA_TARIFF_V1018, unit: 'per_unit', unit_amount_usd: '',
    attributes: {
      media_kind: media, quantity, group: quantity, from: '0', step: '1',
      rounding: 'exact', service_tier: 'standard',
    },
  };
}

const decimal = /^(0|[1-9][0-9]*)(\.[0-9]+)?$/;
const validDecimal = value =>
  typeof value === 'string' && value.length <= 64 && decimal.test(value);
const compareDecimal = (a, b) => {
  const [ai, af = ''] = a.split('.');
  const [bi, bf = ''] = b.split('.');
  const n = Math.max(af.length, bf.length);
  const left = BigInt(ai + af.padEnd(n, '0'));
  const right = BigInt(bi + bf.padEnd(n, '0'));
  return left === right ? 0 : left > right ? 1 : -1;
};

export function mediaTariffErrorV1018(rows, text = (_, en) => en) {
  if (!hasMediaTariffV1018(rows)) return '';
  if (rows.length > 512) return text('媒体费项不能超过 512 项', 'Media tariffs cannot exceed 512 rows');
  const media = rows[0]?.attributes?.media_kind;
  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i], a = row.attributes || {};
    const fail = (cn, en) => `${i + 1}: ${text(cn, en)}`;
    if (row.meter !== MEDIA_TARIFF_V1018 || row.unit !== 'per_unit')
      return fail('媒体规则不能与旧计量项混用', 'Media tariffs cannot mix with legacy meters');
    if (!['video', 'image', 'audio', 'text'].includes(a.media_kind) || a.media_kind !== media)
      return fail('同一基准价必须使用同一媒体类型', 'A base price must use one media type');
    if (!validDecimal(String(row.unit_amount_usd ?? '').trim()))
      return fail('请填写有效的非负价格', 'Enter a valid nonnegative price');
    if (!MEDIA_QUANTITIES_V1018.includes(a.quantity) || !/^[a-z][a-z0-9_]{0,63}$/.test(a.group || ''))
      return fail('请确认计量方式与费项组', 'Check the quantity and charge group');
    for (const k of ['from', 'to', 'step']) {
      if (a[k] !== undefined && !validDecimal(String(a[k])))
        return fail('区间与计费步长必须是非负小数', 'Bounds and billing steps must be nonnegative decimals');
    }
    if ((a.step !== undefined && compareDecimal(String(a.step), '0') <= 0) ||
        (a.to !== undefined && compareDecimal(String(a.to), String(a.from || '0')) <= 0))
      return fail('步长须大于零，区间终点须大于起点', 'Step must be positive and end must exceed start');
    if (!['exact', 'ceil'].includes(a.rounding || 'exact'))
      return fail('请选择有效的取整方式', 'Select a valid rounding policy');
    if (a.optional !== undefined && typeof a.optional !== 'boolean')
      return fail('可选费项设置无效', 'Invalid optional charge setting');
    for (const k of ['when', 'when_min', 'when_max']) {
      if (a[k] === undefined) continue;
      if (!a[k] || typeof a[k] !== 'object' || Array.isArray(a[k]))
        return fail('条件格式无效', 'Invalid condition format');
      for (const [key, value] of Object.entries(a[k])) {
        if (!MEDIA_DIMENSIONS_V1018.includes(key) || typeof value !== 'string' || !value.trim() ||
            (k !== 'when' && (!MEDIA_NUMERIC_DIMENSIONS_V1018.includes(key) || !validDecimal(value))))
          return fail('条件名称或数值无效', 'Invalid condition name or value');
      }
    }
  }
  return '';
}
